import { render, staticRenderFns } from "./TabelaResultadosPerguntas.vue?vue&type=template&id=a4536250&scoped=true&"
import script from "./TabelaResultadosPerguntas.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosPerguntas.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosPerguntas.vue?vue&type=style&index=0&id=a4536250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4536250",
  null
  
)

export default component.exports